import styled from '@emotion/styled';

const S = {};

S.SkipFreeTrial = styled.span`
  label: SkipFreeTrial;

  display: block;
  margin-top: 1rem;
  text-transform: uppercase;
  color: var(--colors-scarpa-flow);
`;

S.SkipFreeTrialCta = styled.span`
  label: SkipFreeTrialCta;

  display: block;
`;

export default S;
